import i18next from 'i18next';

export const changeLanguage = async (
  language: string,
  setLggCookie?: (language: string) => Promise<unknown>
) => {
  await i18next.changeLanguage(language);
  await setLggCookie?.(language);
  window.location.reload();
};
